/**
 * Welcome Header Component
 * Personalized greeting for dashboard
 */
import { Box, Typography, Chip } from '@mui/material';
import { useAuth } from '@/context/AuthContext';

interface WelcomeHeaderProps {
  subtitle?: string;
}

export default function WelcomeHeader({ subtitle }: WelcomeHeaderProps) {
  const { user } = useAuth();

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 18) return 'Good afternoon';
    return 'Good evening';
  };

  const getRoleLabel = () => {
    if (user?.isAdmin) return 'Administrator';
    if (user?.role === 'team_lead') return 'Team Lead';
    return 'Member';
  };

  const getRoleStyles = () => {
    if (user?.isAdmin) return { backgroundColor: '#FEE2E2', color: '#DC2626' };
    if (user?.role === 'team_lead') return { backgroundColor: '#FEF3C7', color: '#D97706' };
    return { backgroundColor: '#F3F4F6', color: '#6B7280' };
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 600 }}>
          {getGreeting()}, {user?.displayName || user?.email?.split('@')[0]}!
        </Typography>
        <Chip
          label={getRoleLabel()}
          size="small"
          sx={{
            fontWeight: 500,
            ...getRoleStyles(),
          }}
        />
      </Box>
      {subtitle && (
        <Typography variant="body1" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}
